const validateImageType = (type: string): boolean => ['Temperatura', 'Precipitacion', 'MagnitudViento', 'VectoresViento'].indexOf(type) > -1

export {
  validateImageType
}
